export default __webpack_public_path__ + "static/media/logoTwo.83576519.png";